/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="!loading"
    aria-labelledby="manageRecordingsRecordings"
  >
    <h2
      id="manageRecordingsRecordings"
      style="margin-top:0"
    >
      Recordings
    </h2>
    <table
      id="manage-recordings-table"
      class="table table-bordered table-condensed table-striped"
    >
      <caption>List of your recordings</caption>
      <thead>
        <tr>
          <th scope="col">
            Title
          </th>
          <th scope="col">
            History
          </th>
          <th scope="col">
            Duration
          </th>
          <th scope="col">
            Vocal Delivery
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="recording in recordings"
          :key="recording.recordingId"
        >
          <td
            scope="row"
          >
            {{ recording.title }}
            <div>
              <a
                href="#"
                @click.prevent="rename(recording)"
              >
                Rename
              </a><br>
              <a
                target="_blank"
                :href="recording.wavUrl"
              >
                Download
              </a><br>
              <a
                href="#"
                @click.prevent="remove(recording)"
              >
                Delete
              </a>
            </div>
          </td>
          <td>
            Uploaded {{ recording.createdDate | date }} {{ toGroup(recording.groupId) }}<br>
            <div v-if="recording.submitted && showLinksForGroup[recording.groupId].submitted">
              Submitted to {{ (orgType === 'edu') ? 'instructor' : 'coach' }}
              on {{ recording.submissionDate | date }},
              <a
                href="#"
                @click.prevent="submit({recordingId: recording.recordingId, submitted: false})"
              >
                Undo
              </a>
              <br>
            </div>
            <div v-if="!recording.submitted && showLinksForGroup[recording.groupId].submitted">
              <a
                href="#"
                @click.prevent="submit({recordingId: recording.recordingId, submitted: true})"
              >
                Submit recording to
                {{ (orgType === 'edu') ? 'instructor' : 'coach' }}
              </a><br>
            </div>
            <div v-if="recording.feedbackRequested && showLinksForGroup[recording.groupId].feedbackRequested">
              Recording shared with entire {{ (orgType === 'edu') ? 'class' : 'group' }} on {{ recording.feedbackRequestedDate | date }},
              <a
                href="#"
                @click.prevent="submit({recordingId: recording.recordingId, feedbackRequested: false})"
              >
                Undo
              </a><br>
            </div>
            <div v-if="!recording.feedbackRequested && showLinksForGroup[recording.groupId].feedbackRequested">
              <a
                href="#"
                @click.prevent="submit({recordingId: recording.recordingId, feedbackRequested: true})"
              >
                Share recording with
                entire {{ (orgType === 'edu') ? 'class' : 'group' }}
              </a><br>
            </div>
          </td>
          <td>
            <span v-if="recording.duration">
              {{ recording.duration | time }}
            </span>
            <span v-if="!recording.duration">
              <span v-if="recording.processing">
                Processing...
              </span>
              <span v-if="recording.failed">
                <svg class="icon-alert-triangle">
                  <use xlink:href="/static/svg-symbols.svg#icon-alert-triangle" />
                </svg>
                Failed
              </span>
            </span>
          </td>
          <td>
            <span v-if="recording.results.scores">
              {{ recording.results.scores.overall }}
            </span>
            <span v-if="!recording.results.scores">
              <span v-if="recording.processing">
                Processing...
              </span>
              <span v-if="recording.failed">
                <svg class="icon-alert-triangle">
                  <use xlink:href="/static/svg-symbols.svg#icon-alert-triangle" />
                </svg>
                Failed
              </span>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="less" scoped>
  #manage-recordings-table div {
    padding-top: 0.5em;
  }
  .icon-alert-triangle {
    width: 15px; height: 15px;
  }
</style>

<script>
export default {
  data() {
    return {
      loading: true,
      showLinksForGroup: {},
    };
  },
  computed: {
    recordings: {
      cache: false,
      get() {
        return this.$store.getters.recordings;
      }
    },
    orgType() {
      return this.$store.getters.org && this.$store.getters.org.type;
    },
    activeGroups() {
      return this.$store.getters.activeGroups;
    }
  },
  created() {
    this.$store.dispatch('listRecordings').then(() => {
      this.loading = false;

      // Decide when to show submission links
      this.activeGroups.forEach((group) => {
        this.showLinksForGroup[group.groupId] = {
          // We show submission links as long as assignments aren't disabled or manager level 1
          submitted: !!(group.managerPrivacyLevel > 1),
          // We don't show feedback when assignments OR feedback are disabled
          // Note, this means you cannot have feedback without assignments
          feedbackRequested: !!(group.speakerPrivacyLevel > 0 && group.speakerPrivacyLevel < 4),
        };
      });
    });
  },
  methods: {
    remove(recording) {
      if (window.confirm('Delete this recording?')) {
        this.$store.dispatch('delRecording', recording.recordingId);
      }
    },
    toGroup(groupId) {
      if (this.activeGroups.length > 1) {
        const g = _.find(this.activeGroups, {groupId});
        return (g && g.name) ? ` to ${g.name}` : '';
      }
      return '';
    },
    rename(recording) {
      const title = window.prompt('Enter new title for this recording', recording.title);
      if (!title) return;

      this.$store.dispatch(
        'updateRecording',
        {
          recordingId: recording.recordingId,
          title
        }
      ).then(() => this.$store.dispatch('listRecordings'));
    },
    submit(data) {
      this.$store.dispatch('updateRecording', data);
    },
  }
};
</script>
